<button ds-toggle-button icon="shopping_cart" [checked]="active()" (click)="onClick()">
  {{ serviceCaseHolder.numberOfElementsInActiveCase | async }}
</button>
